import { MobilephoneSearchService } from '../../services/mobilephone-search.service';
import { Action, State, StateContext } from '@ngxs/store';
import { ApiMobilephoneSearchAction, ApiMobilephoneFiltersAction } from './mobilephone-search.actions';
import { tap, catchError, finalize } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { NotificationService } from '@core/services/notification.service';
import { MobilePhoneFilters } from '../../models/mobilephone-filters';
import { HardwareVariantGroup } from '../../models/mobilephone-variant';

enum Messages {
  MobilePhoneSearchError = 'Feil ved søk',
  MobilePhoneFilterError = 'Feil ved henting av filters',
}

export interface MobilephoneSearchStateModel {
  searchResults: HardwareVariantGroup[];
  isLoadingSearchResults: boolean;
  mobilePhoneFilters: MobilePhoneFilters;
  isLoadingMobilephoneFilters: boolean;
}

@State<MobilephoneSearchStateModel>({
  name: 'mobilephoneSearch',
  defaults: {
    searchResults: [],
    isLoadingSearchResults: false,
    mobilePhoneFilters: null,
    isLoadingMobilephoneFilters: false,
  },
})
@Injectable()
export class MobilephoneSearchState {
  private mobilephoneSearchService = inject(MobilephoneSearchService);
  private notificationService = inject(NotificationService);

  @Action(ApiMobilephoneSearchAction)
  public apiMobilePhoneSearch({ patchState }: StateContext<MobilephoneSearchStateModel>) {
    patchState({ isLoadingSearchResults: true });

    return this.mobilephoneSearchService.getMobilePhoneVariantGroups().pipe(
      tap(mobilePhoneVariants => patchState({ searchResults: mobilePhoneVariants })),
      catchError(error => {
        this.notificationService.error(Messages.MobilePhoneSearchError);
        throw error;
      }),
      finalize(() => patchState({ isLoadingSearchResults: false }))
    );
  }

  @Action(ApiMobilephoneFiltersAction)
  apiMobilephoneFilters({ patchState, getState }: StateContext<MobilephoneSearchStateModel>) {
    const hasCachedResults = getState().mobilePhoneFilters;

    if (hasCachedResults) return;

    patchState({ isLoadingMobilephoneFilters: true });

    return this.mobilephoneSearchService.getMobilephoneFilters().pipe(
      tap(response => patchState({ mobilePhoneFilters: response })),
      catchError(error => {
        this.notificationService.error(Messages.MobilePhoneFilterError);
        throw error;
      }),
      finalize(() => patchState({ isLoadingMobilephoneFilters: false }))
    );
  }
}
